import React from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

export const AppLayout: React.FC = () => (
  <Box component="section">
    <Box component="main" sx={{ p: 0, minHeight: 'calc(100vh - 64px)' }}>
      <Outlet />
    </Box>
  </Box>
);
